<template>
  <div class="topup-back">
    <div class="text">
      <h1>Przyjęliśmy transakcję <span class="no-wrap">do realizacji!</span></h1>
      <p>Dziękujemy, że jesteś z nami!</p>
    </div>
    <div class="button" v-if="!backUrl">
      <button type="button" class="btn" @click="goToTopup">Doładuj ponownie</button>
    </div>
    <div class="button" v-if="backUrl">
      <button type="button" class="btn" @click="goBack">Dalej</button>
    </div>
  </div>
</template>

<script>
import { CookieClass } from '@/common/class/cookie.class'
import { TOPUP_COOKIE_BACK_URL_NAME } from '@/common/const/topup.const'

export default {
  name: 'TopupBack',
  data () {
    return {
      backUrl: null
    }
  },
  methods: {
    goToTopup () {
      document.location.href = this.$VUE_APP_CONFIG.BACK_URL
    },
    goBack () {
      document.location.href = this.backUrl
    }
  },
  created () {
    let backUrl = CookieClass.getCookie(TOPUP_COOKIE_BACK_URL_NAME)
    if (backUrl && backUrl.length) {
      this.backUrl = backUrl
      CookieClass.removeCookie(TOPUP_COOKIE_BACK_URL_NAME)
    }
  }
}
</script>

<style src="../assets/scss/back.scss" lang="scss"></style>
